import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { WechatOfficialAccountModalComponent } from 'src/app/components/wechat-official-account-modal/wechat-official-account-modal.component';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';
import { UserService } from 'src/app/services/user.service';

const DEFAULT_STATUS1 =
  'Processing,Supplemented,ProcessCompleted,NoResponseReceived';

const DEFAULT_STATUS2 = 'NeedToSupplement,ReplyReceived';

const DEFAULT_STATUS3 =
  'Completed,ProactiveCompletion,PassiveCompletion,CustomerServiceCompletion';

const SERVICE_MODAL_STORAGE_KEY = 'has_seen_service_modal';

@Component({
  selector: 'app-user-profile-workorder-page',
  templateUrl: './user-profile-workorder-page.component.html',
  styleUrls: ['./user-profile-workorder-page.component.scss'],
})
export class UserProfileWorkorderPageComponent implements OnInit, OnDestroy {
  query = '';
  queryStatus = DEFAULT_STATUS1;
  list: any;
  interval: any;
  self: any;
  showServiceModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: WorkorderApiService,
    private modal: MatDialog,
    private user: UserService,
  ) {
    this.interval = setInterval(() => {
      this.findList(this.query, this.queryStatus);
    }, 60000);
  }

  ngOnInit(): void {
    // this.showServiceModal = !localStorage.getItem(SERVICE_MODAL_STORAGE_KEY);
    this.findList('', this.queryStatus);
    this.getSelf();
    this.findNeedToSupplementTicket();
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  loading = false;
  async findList(query: string, status: string) {
    try {
      this.loading = true;
      const r = await this.api.findTicket(query, status);
      this.list = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  // onInputChange(event: any) {
  //   this.query = event.target.value;
  //   this.findList(this.query);
  // }

  newWorkorder() {
    this.router.navigate(['/user/profile/form/create']);
  }

  closeServiceModal() {
    this.showServiceModal = false;
    localStorage.setItem(SERVICE_MODAL_STORAGE_KEY, 'true');
  }

  changeDetail(data: any) {
    this.router.navigate(['/user/profile/form/workorder'], {
      queryParams: { id: data.id },
    });
  }

  changeStatusTab(status: string) {
    if (status === 'NoResponseReceived') {
      this.queryStatus = DEFAULT_STATUS1;
    } else if (status === 'ReplyReceived') {
      this.queryStatus = DEFAULT_STATUS2;
    } else this.queryStatus = DEFAULT_STATUS3;
    this.findList('', this.queryStatus);
  }

  hasStatus(status: string): boolean {
    return this.queryStatus.split(',').includes(status);
  }

  openWechatModal() {
    this.modal.open(WechatOfficialAccountModalComponent, {
      data: 'bind',
    });
  }

  async getSelf() {
    try {
      this.self = await this.user.getSelf();
    } catch (error) {}
  }

  flag = false;
  async findNeedToSupplementTicket() {
    try {
      const r = await this.api.findTicket('', 'NeedToSupplement');
      if (r.data.length > 0) this.flag = true;
    } catch (error) {
    } finally {
    }
  }
}
